const breakpoints = [1536, 1280, 1024, 768, 640, 0];

export function Picture({
	imageUrls,
	altText,
	imgClassName,
}: {
	imageUrls: string[];
	altText: string;
	imgClassName: string;
}) {
	return (
		<picture>
			{imageUrls.slice(1).map((x: string, idx: number) => {
				const breakpoint = `(min-width: ${breakpoints[idx]}px)`;
				return <source srcSet={x} media={breakpoint} key={idx} />;
			})}
			<img className={imgClassName} src={imageUrls[0]} alt={altText} loading="lazy" />
		</picture>
	);
}
